export default __webpack_public_path__ + "static/media/xls.e3121683.svg";